import React from "react"
import Icon from "../Icon/Icon"

export default function NavbarOnBelalfBanner({name}: {name: string}) {
	return (
		<div className="navbar-onbehalf-banner">
			<p>
				<Icon icon="view-enable-allow-2-interface-essential-24" size={20} />
				<span>You are viewing as {name}</span>
			</p>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 268 36" fill="none">
				<path
					d="M0 0H268L259.059 30.2665C258.054 33.6666 254.932 36 251.387 36H16.6134C13.0681 36 9.94559 33.6666 8.94116 30.2665L0 0Z"
					fill="#545558"
				/>
			</svg>
		</div>
	)
}
